import React, { useState, useEffect } from 'react'
import classes from "./Business.module.css";
import promix from "../../Assets/Promix.svg"
import authimg from "../../Assets/authimg.png";
import note from "../../Assets/note.svg"
import mil from "../../Assets/mil.svg"
import morter from "../../Assets/morter.svg"
import blue from "../../Assets/blue.svg"
import move from "../../Assets/move.svg"
import { useNavigate, useLocation } from 'react-router';
import api, { BASE_URL } from '../../Components/API/Api';
import Swal from 'sweetalert2';
import { useUser } from '../../UserContext';



import SuccessModal from '../../Components/Modals/SuccessModal';

const Business = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [walletDetails, setWalletDetails] = useState(null);
    const [walletGenerated, setWalletGenerated] = useState(false);
    const [currencies, setCurrencies] = useState([]);
    const [banks, setBanks] = useState([]);
    const [isFetchingBanks, setIsFetchingBanks] = useState(false);
    const [industries, setIndustries] = useState([]);
    const [isFetchingIndustries, setIsFetchingIndustries] = useState(false);
    const [countries, setCountries] = useState([]);
    const [isFetchingCountries, setIsFetchingCountries] = useState(false);
    const [states, setStates] = useState([]);
    const [isFetchingStates, setIsFetchingStates] = useState(false);

    // Fallback currencies in case API fetch fails (common currencies)
    const fallbackCurrencies = [
        { id: 1, code: 'NGN', symbol: '₦', country: 'Nigeria', currency: 'Naira' },
        { id: 2, code: 'USD', symbol: '$', country: 'United States of America', currency: 'American Dollar' },
        { id: 3, code: 'EUR', symbol: '€', country: 'Belgium', currency: 'Euro' },
        { id: 4, code: 'GBP', symbol: '£', country: 'United Kingdom', currency: 'British Pound' },
        { id: 5, code: 'GHS', symbol: '₵', country: 'Ghana', currency: 'Ghanaian Cedi' },
        { id: 6, code: 'KES', symbol: 'KSh', country: 'Kenya', currency: 'Kenyan Shilling' },
        { id: 7, code: 'ZAR', symbol: 'R', country: 'South Africa', currency: 'South African Rand' },
    ];
    const [formData, setFormData] = useState({
        company_name: '',
        company_address: '',
        company_email: '',
        company_phone: '',
        industry: '',
        country: '',
        country_id: '',
        state: '',
        bvn: '',
        // vat_registration: '',
        // currency_base: '',
        // financial_year: '',
        // account_method: '',
        // vat_rate: '',
        business_start_date: '',
        // bank_id: '',
        // account_number: '',
        // account_name: '',
        termsAccepted: false
    });

    // Fetch currencies on component mount - matching ActionPage.js pattern exactly
    useEffect(() => {
        const fetchCurrencies = async () => {
            try {
                // Try authToken first (for logged in users), then token (registration token)
                const token = localStorage.getItem("authToken") || localStorage.getItem("token");

                // Try with token first
                if (token) {
                    try {
                        const currencyRes = await api.get(`/v1/fetch-all-currencies`);

                        // Match ActionPage.js: set currencies directly from currencyRes.data.data
                        if (currencyRes?.data?.data) {
                            setCurrencies(currencyRes.data.data);
                            console.log("Currencies fetched:", currencyRes.data.data.length, "items");

                            // Set NGN as default if available - matching ActionPage.js logic
                            const ngn = currencyRes.data.data.find(cur =>
                                (cur.code && String(cur.code).toUpperCase() === 'NGN') ||
                                (cur.symbol && (String(cur.symbol).includes('₦') || String(cur.symbol).toUpperCase() === 'NGN')) ||
                                (cur.country && String(cur.country).toLowerCase().includes('nigeria'))
                            );
                            if (ngn) {
                                setFormData(prev => ({ ...prev, currency_base: String(ngn.id) }));
                            }
                            return; // Success, exit early
                        }
                    } catch (err) {
                        // If plan_id error, try without auth as fallback
                        const errorMessage = err?.response?.data?.message;
                        const isPlanIdError = errorMessage?.includes('plan_id');

                        if (isPlanIdError) {
                            console.warn("Currency fetch failed due to plan_id middleware issue. Trying without auth...");
                            // Try without auth as fallback
                            try {
                                const currencyRes = await api.get(`/v1/fetch-all-currencies`);

                                if (currencyRes?.data?.data) {
                                    setCurrencies(currencyRes.data.data);
                                    const ngn = currencyRes.data.data.find(cur =>
                                        (cur.code && String(cur.code).toUpperCase() === 'NGN') ||
                                        (cur.symbol && (String(cur.symbol).includes('₦') || String(cur.symbol).toUpperCase() === 'NGN')) ||
                                        (cur.country && String(cur.country).toLowerCase().includes('nigeria'))
                                    );
                                    if (ngn) {
                                        setFormData(prev => ({ ...prev, currency_base: String(ngn.id) }));
                                    }
                                    return; // Success without auth
                                }
                            } catch (noAuthErr) {
                                console.warn("Currency fetch without auth also failed, using fallback currencies");
                            }
                        } else {
                            throw err; // Re-throw if not plan_id error
                        }
                    }
                }

                // If we get here, both attempts failed - use fallback currencies
                console.warn("Using fallback currencies due to API fetch failure");
                setCurrencies(fallbackCurrencies);
                const ngn = fallbackCurrencies.find(cur => cur.code === 'NGN');
                if (ngn) {
                    setFormData(prev => ({ ...prev, currency_base: String(ngn.id) }));
                }
            } catch (err) {
                console.error("Failed to fetch currencies:", err);
                // Use fallback currencies as last resort
                setCurrencies(fallbackCurrencies);
                const ngn = fallbackCurrencies.find(cur => cur.code === 'NGN');
                if (ngn) {
                    setFormData(prev => ({ ...prev, currency_base: String(ngn.id) }));
                }
            }
        };

        fetchCurrencies();
    }, []);

    // Fetch Paystack banks for Bank Name select field
    useEffect(() => {
        const fetchBanks = async () => {
            try {
                setIsFetchingBanks(true);
                const token = localStorage.getItem("authToken") || localStorage.getItem("token");

                if (!token) {
                    console.warn("No token found while fetching Paystack banks");
                    return;
                }

                const res = await api.get(`/v1/banks_for_setup`);

                const banksData = Array.isArray(res?.data?.data) ? res.data.data : [];
                setBanks(banksData);
            } catch (error) {
                console.error("Failed to fetch Paystack banks", error);
            } finally {
                setIsFetchingBanks(false);
            }
        };

        fetchBanks();
    }, []);

    // Fetch industries from API
    useEffect(() => {
        const fetchIndustries = async () => {
            try {
                setIsFetchingIndustries(true);
                const token = localStorage.getItem("authToken") || localStorage.getItem("token");

                if (!token) {
                    console.warn("No token found while fetching industries");
                    return;
                }

                const res = await api.get(`/v1/industry`);

                const industriesData = Array.isArray(res?.data?.data) ? res.data.data : [];
                setIndustries(industriesData);
            } catch (error) {
                console.error("Failed to fetch industries", error);
            } finally {
                setIsFetchingIndustries(false);
            }
        };

        fetchIndustries();
    }, []);

    // Fetch countries from API
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                setIsFetchingCountries(true);
                const token = localStorage.getItem("authToken") || localStorage.getItem("token");

                if (!token) {
                    console.warn("No token found while fetching countries");
                    return;
                }

                const res = await api.get(`/v1/get_countries`);

                const countriesData = Array.isArray(res?.data?.data) ? res.data.data : [];
                setCountries(countriesData);
            } catch (error) {
                console.error("Failed to fetch countries", error);
            } finally {
                setIsFetchingCountries(false);
            }
        };

        fetchCountries();
    }, []);

    // Fetch states based on selected country
    useEffect(() => {
        const fetchStates = async () => {
            if (!formData.country_id) {
                setStates([]);
                return;
            }

            try {
                setIsFetchingStates(true);
                const token = localStorage.getItem("authToken") || localStorage.getItem("token");

                if (!token) {
                    console.warn("No token found while fetching states");
                    return;
                }

                const res = await api.get(`/v1/get_states_by_country`, {
                    params: { country_id: formData.country_id },
                });

                const statesData = Array.isArray(res?.data?.data) ? res.data.data : [];
                setStates(statesData);
            } catch (error) {
                console.error("Failed to fetch states", error);
                setStates([]);
            } finally {
                setIsFetchingStates(false);
            }
        };

        fetchStates();
    }, [formData.country_id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        // Special handling for country selection
        if (name === 'country') {
            // Find the selected country object to get the ID
            const selectedCountry = countries.find(c => {
                const countryName = c?.name || c?.country_name || c?.country || '';
                return countryName === value;
            });
            
            const countryId = selectedCountry?.id || selectedCountry?.country_id || selectedCountry?.countryId || '';
            
            setFormData(prev => ({
                ...prev,
                country: value,
                country_id: countryId,
                state: '' // Reset state when country changes
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleCheckboxChange = (e) => {
        setFormData(prev => ({
            ...prev,
            termsAccepted: e.target.checked
        }));
    };

    const handleCloseModal = () => {
        setShowSuccessModal(false);
        const companyId = localStorage.getItem('company_id') || localStorage.getItem('activeCompanyId');
        const industryId = localStorage.getItem('industryId') || localStorage.getItem('selectedIndustryId');
        navigate('/pricing-new', {
            state: { 
                company_id: companyId,
                industryId: industryId,
                selectedPlan: location.state?.selectedPlan
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.termsAccepted) {
            Swal.fire('Error', 'Please accept the Terms of Service and Privacy Policy', 'error');
            return;
        }

        // Determine how user reached this page:
        // - from OTP verification flow (OnboardOTP.js) => use /v1/company_setup
        // - from dashboard or anywhere else            => use /v1/complete_company_setup
        const isFromOtpFlow = location?.state?.fromOtp === true;

        // Tokens:
        // - authToken: user already signed in (e.g. redirected from dashboard to complete setup)
        // - token: registration token (OTP/registration flow, used with /v1/company_setup)
        const authToken = localStorage.getItem("authToken");
        const registrationToken = localStorage.getItem("token");

        // Debug: log available tokens
        console.log("Available tokens:", {
            token: registrationToken ? "Found" : "Not found",
            authToken: authToken ? "Found" : "Not found",
            email: localStorage.getItem("email")
        });

        // Validate required auth/registration tokens based on how user got here
        if (isFromOtpFlow) {
            // OTP onboarding flow must use the registration token
            if (!registrationToken) {
                Swal.fire({
                    icon: 'error',
                    title: 'Registration Token Missing',
                    text: 'Your onboarding session has expired. Please restart the signup process.',
                });
                return;
            }
        } else {
            // Coming from dashboard or other signed-in paths must use authToken
            if (!authToken) {
                Swal.fire({
                    icon: 'error',
                    title: 'Authentication Required',
                    text: 'Please sign in again to continue.',
                });
                return;
            }
        }

        // Validate required fields
        const requiredFields = [
            'company_name', 'company_address', 'company_email', 'company_phone',
            'industry', 'country', 'state', 'business_start_date', 'bvn',
            // 'vat_registration', 'currency_base', 'financial_year',
        ];

        const missingFields = requiredFields.filter(field => !formData[field]);
        if (missingFields.length > 0) {
            Swal.fire('Error', `Please fill in all required fields: ${missingFields.join(', ')}`, 'error');
            return;
        }

        setLoading(true);

        try {
            const payload = {
                company_name: formData.company_name,
                company_address: formData.company_address,
                company_email: formData.company_email,
                company_phone: formData.company_phone,
                industry: formData.industry,
                country: formData.country,
                state: formData.state,
                bvn: formData.bvn,
                // vat_registration: formData.vat_registration,
                // currency_base: Number(formData.currency_base),
                // financial_year: formData.financial_year,
                // account_method: formData.account_method,
                // vat_rate: formData.vat_rate,
                business_start_date: formData.business_start_date,
                // bank_id: formData.bank_id,
                // account_number: formData.account_number,
                // account_name: formData.account_name
            };

            // Build payload and endpoint based on flow source
            let finalPayload;
            let endpoint;
            let bearerToken;

            if (isFromOtpFlow) {
                // Coming directly from OTP verification: use /v1/company_setup
                endpoint = `${BASE_URL}/v1/company_setup`;
                finalPayload = { ...payload, registration_token: registrationToken };
                bearerToken = registrationToken;
            } else {
                // Coming from dashboard or other signed-in entry point: use /v1/complete_company_setup
                endpoint = `${BASE_URL}/v1/complete_company_setup`;
                finalPayload = payload;
                bearerToken = authToken;
            }

            // Use api.post with the configured endpoint (remove BASE_URL since api already has it)
            const actualEndpoint = endpoint.replace(BASE_URL, '');
            const res = await api.post(actualEndpoint, finalPayload);

            if (res.data?.status !== false) {
                // Extract and store token from response if available
                // Token can be returned in several possible keys
                const responseToken = res.data?.data?.token
                    || res.data?.data?.access_token
                    || res.data?.token
                    || res.data?.access_token;

                const companyID = res.data?.data?.company?.id
                    || res.data?.data?.company_id
                    || res.data?.data?.company?.company_id
                    || res.data?.data?.companyId
                    || res.data?.data?.id
                    || res.data?.company_id
                    || res.data?.id;

                const companyInfo = res.data?.data?.company || res.data?.company || null;

                if (responseToken) {
                    localStorage.setItem("authToken", responseToken);
                    localStorage.setItem("token", responseToken);
                }

                if (companyID) {
                    localStorage.setItem("company_id", String(companyID));
                    localStorage.setItem("activeCompanyId", String(companyID));
                    console.log("Company ID stored:", companyID);
                }

                // Extract industry_id from response or use formData.industry
                const industryId = res.data?.data?.industry_id 
                    || res.data?.data?.company?.industry_id 
                    || formData.industry;

                if (industryId) {
                    localStorage.setItem("industryId", String(industryId));
                    localStorage.setItem("selectedIndustryId", String(industryId));
                    console.log("Industry ID stored:", industryId);
                }

                const userData = {
                    email: formData.company_email,
                    company_name: formData.company_name,
                    company_address: formData.company_address,
                    company_phone: formData.company_phone,
                    industry: formData.industry,
                    country: formData.country,
                    state: formData.state,
                    company_id: companyID ? String(companyID) : undefined,
                    industry_id: industryId ? String(industryId) : undefined,
                    company: companyInfo,
                };

                try {
                    localStorage.setItem("userData", JSON.stringify(userData));
                } catch (e) {
                    console.error("Failed to persist userData after company setup", e);
                }

                localStorage.setItem("selectedIndustryId", String(industryId || formData.industry));

                if (responseToken) {
                    console.log("Token stored after company registration:", responseToken.substring(0, 10) + "...");
                }

                // Prepare wallet details for modal
                const responseData = res.data?.data || {};
                const walletInfo = responseData.wallet || {};

                // Check if wallet was actually generated (has real data)
                const hasRealWalletData = walletInfo.wallet_account_number && 
                                         walletInfo.wallet_account_name && 
                                         walletInfo.authorized_bank;

                // Get user data from context or localStorage
                let userFirstName = user?.firstName;
                let userLastName = user?.lastName;
                if (!userFirstName || !userLastName) {
                    try {
                        const storedUser = localStorage.getItem("user");
                        if (storedUser) {
                            const parsedUser = JSON.parse(storedUser);
                            userFirstName = parsedUser.firstName || userFirstName;
                            userLastName = parsedUser.lastName || userLastName;
                        }
                    } catch (error) {
                        console.error("Failed to parse user data from localStorage:", error);
                    }
                }

                // Only set wallet details if they were actually generated
                if (hasRealWalletData) {
                    setWalletDetails({
                        walletId: walletInfo.wallet_account_number,
                        walletName: walletInfo.wallet_account_name,
                        bankName: walletInfo.authorized_bank,
                    });
                    setWalletGenerated(true);
                } else {
                    setWalletGenerated(false);
                }

                setShowSuccessModal(true);
            } else {
                throw new Error(res.data?.message || 'Setup failed');
            }

        } catch (error) {
            console.error('Company setup error:', error);
            const errorResponse = error?.response?.data;
            const errorMessage = errorResponse?.message;
            const exception = errorResponse?.exception;

            // Check for specific backend errors
            if (exception === 'ErrorException' && errorMessage?.includes('plan_id')) {
                Swal.fire({
                    icon: 'error',
                    title: 'Setup Error',
                    text: 'There was an issue with your account setup. Please contact support or try again later.',
                    footer: 'Error: ' + errorMessage
                });
            } else if (errorMessage && typeof errorMessage === 'object') {
                // Handle validation errors
                const errorList = Object.entries(errorMessage)
                    .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages[0] : messages}`)
                    .join('\n');
                Swal.fire('Validation Error', errorList, 'error');
            } else {
                // Display the actual error message from backend
                const displayMessage = errorMessage || error?.message || 'Failed to setup company. Please try again.';
                Swal.fire({
                    icon: 'error',
                    title: 'Setup Failed',
                    text: displayMessage,
                    ...(exception ? { footer: `Exception: ${exception}` } : {})
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className={classes.main}>
                <div className={classes.leftside}>

                    <div className={classes.grit}>
                        <img src={promix} className={classes.pro} alt="Promix Logo" />
                        <p className={classes.fir_txt}>
                            <span className={classes.fir_txtRest}>Smart </span>
                            <span className={classes.fir_txtAccent}>Accounting</span>
                            <span className={classes.fir_txtRest}> for Nigerian Businesses</span>
                        </p>
                        <p className={classes.sec_txt}>
                            Trusted by SMEs across Nigeria to manage their finances smarter
                        </p>

                        <div>
                            <img src={authimg} className={classes.authimgleft} alt="Authentication illustration" />
                        </div>
                    </div>
                </div>
                {/* <div className={classes.leftside}>
                    <img src={bigcirlce} className={classes.paint} />
                    <img src={smallcirlce} className={classes.point} />

                    <img src={promix} className={classes.pro} />
                    <p className={classes.fir_txt}>Join 10,000+ Nigerian Businesses</p>
                    <p className={classes.sec_txt}>Start your journey to better financial management with our
                        comprehensive accounting platform</p>

                    <div className={classes.joptd}>
                        <div>
                            <img src={cal} />
                        </div>
                        <div>
                            <p className={classes.cro_pt}>Complete Accounting Suite</p>
                            <p className={classes.mind}>Everything you need to manage your finances</p>
                        </div>
                    </div>
                    <div className={classes.joptd}>
                        <div>
                            <img src={accend} />
                        </div>
                        <div>
                            <p className={classes.cro_pt}>Growth Analytics</p>
                            <p className={classes.mind}>Track your business growth with detailed reports</p>
                        </div>
                    </div>
                    <div className={classes.joptd}>
                        <div>
                            <img src={corporate} />
                        </div>
                        <div>
                            <p className={classes.cro_pt}>Team Collaboration</p>
                            <p className={classes.mind}>Work together with your team seamlessly</p>
                        </div>
                    </div>

                    <div className={classes.mvt}>
                        <button className={classes.pthd}>View Features</button>
                        <button className={classes.simp}>Contact Sales</button>
                    </div>
                    <img src={smallsquare} className={classes.bi_squ} />
                    <img src={bigsquare} className={classes.sm_squ} />
                </div> */}

                <div className={classes.right}>
                    <div className={classes.protw}>
                        <p className={classes.cre_top}>Company Information</p>
                        <p className={classes.adkt}>Provide business details to continue.</p>
                        {/* <p className={classes.adkt}>Tell us about your business to get started.</p> */}
                    </div>

                    {/* <form onSubmit={handleSubmit}> */}
                    <form>
                        <div className={classes.matt} style={{ paddingTop: '0px' }}>
                            <label className={classes.lab_el}>Company Name</label>
                            <div className={classes.noteIcon}>
                                <input
                                    type='text'
                                    name='company_name'
                                    value={formData.company_name}
                                    onChange={handleInputChange}
                                    placeholder='Enter your company name'
                                    className={classes.print2}
                                    required
                                />
                                <img src={note} className={classes.note} alt="" />
                            </div>
                        </div>

                        <div className={classes.matt} style={{ paddingTop: '0px' }}>
                            <label className={classes.lab_el}>Company Address</label>
                            <div className={classes.noteIcon}>
                                <input
                                    type='text'
                                    name='company_address'
                                    value={formData.company_address}
                                    onChange={handleInputChange}
                                    placeholder='Enter your company address'
                                    className={classes.print2}
                                    required
                                />
                                <img src={mil} className={classes.note} alt="" />
                            </div>
                        </div>

                        <div className={classes.portned}>

                            <div>

                                <div className={classes.james}>
                                    <div className={classes.notIcon}>
                                        <label className={classes.lab_el}>Company Email</label>
                                        <div className={classes.noteIcon}>
                                            <input
                                                type='email'
                                                name='company_email'
                                                value={formData.company_email}
                                                onChange={handleInputChange}
                                                placeholder='Enter your company email'
                                                className={classes.print}
                                                required
                                            />
                                            <img src={blue} className={classes.note} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Business Start Date</label>
                                    <input
                                        type='date'
                                        name='business_start_date'
                                        value={formData.business_start_date}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                    />
                                </div>
                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Country of Operation</label>
                                    <select
                                        name='country'
                                        value={formData.country}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                    >
                                        <option value="">
                                            {isFetchingCountries ? 'Loading countries...' : 'Select country of operation'}
                                        </option>
                                        {countries.map((country) => {
                                            const countryId = country?.id || country?.country_id || country?.countryId;
                                            const countryName = country?.name || country?.country_name || country?.country || '';
                                            return (
                                                <option key={countryId} value={countryName}>
                                                    {countryName}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                               

                                {/* <div className={classes.james}>
                                    <label className={classes.lab_el}>VAT Registration</label>
                                    <div className={classes.noteIcon}>
                                        <input
                                            type='text'
                                            name='vat_registration'
                                            value={formData.vat_registration}
                                            onChange={handleInputChange}
                                            placeholder='Enter VAT registration number'
                                            className={classes.print}
                                            required
                                        />
                                    </div>
                                 </div>
                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Financial Year</label>
                                    <input
                                        type='date'
                                        name='financial_year'
                                        value={formData.financial_year}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                    />
                                </div>

                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Bank Name</label>
                                    <select
                                        name='bank_id'
                                        value={formData.bank_id}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                    >
                                        <option value="">
                                            {isFetchingBanks ? 'Loading banks...' : 'Select Bank'}
                                        </option>
                                        {banks.map((bank) => (
                                            <option key={bank.id || bank.code} value={bank.id || bank.code}>
                                                {bank.name || bank.bank_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>


                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Account Number</label>
                                    <input
                                        type='number'
                                        name='account_number'
                                        value={formData.account_number}
                                        onChange={handleInputChange}
                                        placeholder='Enter account number'
                                        className={classes.printer}
                                        required
                                    />
                                </div> */}
                            </div>


                            <div>
                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Phone</label>
                                    <div className={classes.noteIcon}>
                                        <input
                                            type='tel'
                                            name='company_phone'
                                            value={formData.company_phone}
                                            onChange={handleInputChange}
                                            placeholder='Enter your Phone number'
                                            className={classes.print}
                                            required
                                        />
                                        <img src={morter} className={classes.note} />
                                    </div>
                                </div>

                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Industry</label>
                                    <select
                                        name='industry'
                                        value={formData.industry}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                    >
                                        <option value="">
                                            {isFetchingIndustries ? 'Loading industries...' : 'Select Industry'}
                                        </option>
                                        {industries.map((c, idx) => {
                                        const id = c?.id || c?.company_id || c?.companyId || idx;
                                        return (
                                            <option key={id} value={id}>
                                            {c.name || ''}
                                            </option>
                                        );
                                        })}
                                        {/* {industries.map((industry) => (
                                            <option key={industry.id || industry.name} value={industry.id}>
                                                {industry.name}
                                            </option>
                                        ))} */}
                                    </select>
                                </div>

                                <div className={classes.james}>
                                    <label className={classes.lab_el}>States</label>
                                    <select
                                        name='state'
                                        value={formData.state}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                        disabled={!formData.country_id || isFetchingStates}
                                    >
                                        <option value="">
                                            {!formData.country_id ? 'Select country first' : isFetchingStates ? 'Loading states...' : 'Select State'}
                                        </option>
                                        {states.map((state) => {
                                            const stateId = state?.id || state?.state_id || state?.stateId;
                                            const stateName = state?.name || state?.state_name || state?.state || '';
                                            return (
                                                <option key={stateId} value={stateName}>
                                                    {stateName}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                {/* <div className={classes.james}>
                                    <label className={classes.lab_el}>Base Currency</label>
                                    <select
                                        name='currency_base'
                                        value={formData.currency_base}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                    >
                                        <option value="">Select Base Currency</option>
                                        {currencies.map((currency) => (
                                            <option key={currency.id} value={String(currency.id)}>
                                                {currency.symbol} {currency.code} - {currency.country}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Account Method</label>
                                    <select
                                        name='account_method'
                                        value={formData.account_method}
                                        onChange={handleInputChange}
                                        className={classes.printer}
                                        required
                                    >
                                        <option value="">Select account method</option>
                                        <option value="cash">Cash Basis</option>
                                        <option value="accrual">Accrual Basis</option>
                                    </select>
                                </div>

                                <div className={classes.james}>
                                    <label className={classes.lab_el}>VAT Rate (%)</label>
                                    <input
                                        type='number'
                                        name='vat_rate'
                                        value={formData.vat_rate}
                                        onChange={handleInputChange}
                                        placeholder='e.g., 7.5'
                                        className={classes.printer}
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        required
                                    />
                                </div>




                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Account Name</label>
                                    <input
                                        type='text'
                                        name='account_name'
                                        value={formData.account_name}
                                        onChange={handleInputChange}
                                        placeholder='Enter account name'
                                        className={classes.printer}
                                        required
                                    />
                                </div>*/}
                            </div>

                        </div>

                        <div className={classes.matt} style={{ paddingTop: '0px' }}>
                            <label className={classes.lab_el}>BVN (Biometric Verification Number)</label>
                            <div className={classes.noteIcon}>
                                <input
                                    type='text'
                                    name='bvn'
                                    value={formData.bvn}
                                    onChange={handleInputChange}
                                    placeholder='Enter your BVN'
                                    className={classes.print2}
                                    required
                                />
                                <img src={move} className={classes.note} alt="" />
                            </div>
                        </div>

                        <div className={classes.joshe}>
                            <div className={classes.pintoe}>
                                <input
                                    type='checkbox'
                                    checked={formData.termsAccepted}
                                    onChange={handleCheckboxChange}
                                    className={classes.shipet}
                                    required
                                />
                                <p className={classes.abode}>By continuing, you agree to  <span className={classes.crit}> our Terms of Service and Privacy Policy</span> </p>
                            </div>
                        </div>
                        <button
                            type='button'
                            className={classes.sign}
                            disabled={loading}
                            onClick={(e) => {
                                e.preventDefault();

                                if (!formData.industry) {
                                    return Swal.fire(
                                        'Select company',
                                        'Please select a company to continue',
                                        'warning'
                                    );
                                }

                                const sel = industries.find(
                                    (c) =>
                                        String(c?.id || c?.company_id || c?.companyId) ===
                                        String(formData.industry)
                                );

                                if (sel) {
                                    const chosenId =
                                        sel?.id ||
                                        sel?.company_id ||
                                        sel?.companyId ||
                                        formData.industry;

                                    localStorage.setItem('companyInfo', JSON.stringify(sel));
                                    localStorage.setItem('company_id', String(chosenId));
                                }

                                handleSubmit(e);
                            }}
                        >
                            <span>{loading ? 'Submitting...' : 'Continue'}</span>
                            {!loading && (
                                <span>
                                    <img src={move} alt="" />
                                </span>
                            )}
                        </button>
                    </form>

                </div>

            </div>
            <SuccessModal
                isOpen={showSuccessModal}
                onClose={handleCloseModal}
                walletDetails={walletDetails}
                walletGenerated={walletGenerated}
            />
        </div>
    )
}

export default Business
